export default __webpack_public_path__ + "static/media/img_step_hami11.ea16b11d.png";